export const createJSONFile = (fileName: string, result: string): void => {
  const link = document.createElement('a');
  const file = new Blob([result], { type: 'json' });
  link.href = URL.createObjectURL(file);
  link.download = `${fileName}.json`;
  link.click();
};